export const SERVERURL = "texephyr.live";
export const FRONTENDURL = "https://texephyr.in/"
export const AUTHAPIURL = `https://${SERVERURL}/api/auth/`
export const USERAPIURL = `https://${SERVERURL}/api/webuser/`
export const ADMINAPIURL = `https://${SERVERURL}/api/webadmin/`